import { useNavigate } from 'react-router-dom';
import API from '../../api';
import { toast } from 'react-toastify';

const API_URL = '/api/customers';

const validateToken = async (token, navigate, setLoading) => {
  try {
    const response = await API.get(
      `${API_URL}/validate-reset-token?token=${token}`
    );
    setLoading(false);
  } catch (error) {
    toast.error(error?.response?.data?.error?.message ?? error?.message);
    setTimeout(() => {
      navigate('/resend-email');
    }, 2000);
  }
};

export default validateToken;
